"use client";

import { createContext, useContext } from "react";

// Client-side context populated server-side from the homegrown DB-backed
// feature flags (`lib/feature-flags.ts` + admin UI at /admin/feature-flags).
//
// Use the `useAppFeatureFlag(key)` hook in client components instead of
// posthog-js's `useFeatureFlagEnabled` — PostHog flag eval has cookie-
// consent gating, multi-signal bot detection, and cross-environment
// targeting quirks that bit us hard during Phase 9. The DB-backed system
// is server-side, environment-isolated by virtue of separate DBs per
// environment, and toggleable from /admin/feature-flags inside the app.
//
// See `docs/INFRASTRUCTURE.md` "Feature flags" section for the full
// recommendation on which system to use when.

const FeatureFlagsContext = createContext<Record<string, boolean>>({});

export function AppFeatureFlagsProvider({
  flags,
  children,
}: {
  flags: Record<string, boolean>;
  children: React.ReactNode;
}) {
  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useAppFeatureFlag(key: string): boolean {
  const flags = useContext(FeatureFlagsContext);
  return flags[key] === true;
}
